import React, { useContext, useState, } from 'react';
import { useFetch } from '../api/useFetch';
import { useUserContext } from './user_context';

export const SupplierContext = React.createContext();


export const SupplierProvider = ({ children }) => {

    const { btoken, } = useUserContext();

    let data = { btoken, };

    const {
        loading: supplierLoading, data: allSuppliers, fetchData: getSupplierData
    } = useFetch('/getSuppliers', data);



    const [showAddSupplier, setShowAddSupplier] = useState(false);
    const CloseAddSupplier = () => setShowAddSupplier(false);
    const openAddSupplier = () => setShowAddSupplier(true);

    const [showEditSupplier, setShowEditSupplier] = useState(false);
    const CloseEditSupplier = () => setShowEditSupplier(false);
    const openEditSupplier = () => setShowEditSupplier(true);

    return (
        <SupplierContext.Provider value={{

            showAddSupplier, CloseAddSupplier, openAddSupplier,
            showEditSupplier, CloseEditSupplier, openEditSupplier,

            supplierLoading, allSuppliers, getSupplierData,
        }}>
            {children}
        </SupplierContext.Provider>
    );
};

// make sure use
export const useSupplierContext = () => {
    return useContext(SupplierContext);
};
